<!-- Used on BibItem Page -->
<button type="button" class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none"
  data-bs-toggle="modal" data-bs-target="#collectionModal" *ngIf="page=='bibitem' && USERID!=''; else NoLogin">
  <span><i class="bi bi-heart"></i> {{ 'Collections' | translate }}</span>
</button>

<ng-template #NoLogin>
  <a *ngIf="page=='bibitem'" href="login"
    class="btn btn-sm btn-light btn-light-walai border rounded-pill text-dark px-3 shadow-none">
    <span><i class="bi bi-heart"></i> {{ 'Collections' | translate }}</span>
  </a>
</ng-template>

<!-- Used on Other Pages (just icon) -->
<a data-bs-toggle="modal" data-bs-target="#collectionModal" class="text-decoration-none" style="cursor: pointer;"
  *ngIf="page!='bibitem' && USERID!=''; else NoLogin1">
  <i class="bi bi-heart text-secondary fs-5"></i>
</a>
<ng-template #NoLogin1>
  <a *ngIf="page!='bibitem'" href="login" class="text-decoration-none">
    <i class="bi bi-heart text-secondary fs-5"></i>
  </a>
</ng-template>

<!-- Modal -->
<div class="modal fade" id="collectionModal" tabindex="-1" role="dialog" aria-labelledby="collectionModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-bold text-dark" id="collectionModalLabel">
          <i class="bi bi-bookmark-heart-fill me-2 text-danger"></i>{{ 'SaveToCollection' | translate }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <!-- New List Toggle -->
        <div class="mb-3">
          <a data-bs-toggle="collapse" href="#collapseNewList" role="button" aria-expanded="false"
            aria-controls="collapseNewList" class="new-list-btn">
            <i class="bi bi-plus-lg"></i> {{ 'CreateNewList' | translate }}
          </a>
        </div>

        <!-- New List Form -->
        <div class="collapse mb-4" id="collapseNewList">
          <form [formGroup]="addCollectionForm">
            <div class="card new-list-form-card p-3 bg-white">
              <div class="form-group mb-3">
                <label for="list-name" class="form-label text-secondary small fw-bold">{{ 'ListName' | translate
                  }}</label>
                <input type="text" class="form-control" id="list-name" formControlName="addCollectionForm_name"
                  placeholder="e.g., Thesis References" />
              </div>
              <div class="text-end">
                <button type="button" class="btn btn-primary rounded-pill px-4" [disabled]="!addCollectionForm.valid"
                  (click)="addCollection()">
                  {{ 'CreateList' | translate }}
                </button>
              </div>
            </div>
          </form>
        </div>

        <!-- Collection List -->
        <div class="d-flex flex-column gap-2">
          <div class="collection-card p-3 d-flex align-items-center" *ngFor="let item of collectionList">
            <!-- Cover Image -->
            <div class="shrink-0">
              <img *ngIf="item.Collctions.length > 0; else NoBookCover" class="collection-cover shadow-sm"
                src="{{ item.Collctions[0].BookCover }}" onError="this.src='./assets/images/bookcover/noimage.jpg'"
                fluid />
              <ng-template #NoBookCover>
                <img class="collection-cover shadow-sm opacity-50" src="./assets/images/bookcover/noimage.jpg" />
              </ng-template>
            </div>

            <!-- Info -->
            <div class="collection-info">
              <span class="collection-name">{{ item.NAME }}</span>
              <span class="collection-count">
                <i class="bi bi-book me-1"></i>{{ item.Collctions.length }} {{ 'Records' | translate }}
              </span>
            </div>

            <!-- Action -->
            <div class="shrink-0">
              <button class="btn btn-action-icon btn-remove" (click)="deletebib(item.MLID)"
                *ngIf="item.HaveBibID; else AddBtn" [title]="'Remove' | translate">
                <i class="bi bi-dash-circle-fill fs-4"></i>
              </button>
              <ng-template #AddBtn>
                <button class="btn btn-action-icon btn-add" (click)="addbib(item.MLID)" [title]="'Add' | translate">
                  <i class="bi bi-plus-circle-fill fs-4"></i>
                </button>
              </ng-template>
            </div>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light text-secondary fw-bold rounded-pill px-4 border"
          data-bs-dismiss="modal">{{ 'Done' | translate }}</button>
      </div>
    </div>
  </div>
</div>